(function() {
    angular.module('emarket.commons').directive('compareTo', function() {
        return {
            require: 'ngModel',
            scope: {
                otherModelValue: '=compareTo'
            },
            link: function(scope, element, attributes, ngModel) {
                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue === scope.otherModelValue;
                };

                var stopWatch = scope.$watch('otherModelValue', function() {
                    ngModel.$validate();
                });
                scope.$on('$destroy', function() {
                    stopWatch();
                });
            }
        };
    });
}());
